import React, { useState, useContext, useEffect } from 'react';
import { Card, Table, NavDropdown } from 'react-bootstrap';
import { useWidgetContext } from '../context/DragContext';
import { AuthContext } from '../context/AuthContext';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import { useLocation, useNavigate } from 'react-router-dom';
import SwitchAccount from '../common/SwitchAccount';

function Watchlist() {
  const [showDropdown, setShowDropdown] = useState(false);
  const { removeWidgetFromGrid } = useWidgetContext();
  const { watchlistData, currentDate, currentTime, watchListLoading, userData } = useContext(AuthContext);
  const [switchAccount, setSwitchAccount] = useState(false);
  const location = useLocation(); 
  const navigate = useNavigate();
  const token = localStorage.getItem('accessToken');
  const [hasAutoOpenedSwitchAccount, setHasAutoOpenedSwitchAccount] = useState(false);
  const isDemoPath = location.pathname === '/demo';

  const handleOpenSwitchAccount = () => setSwitchAccount(true);
  const handleCloseSwitchAccount = () => setSwitchAccount(false);

  const handleToggle = (isOpen) => {
    setShowDropdown(isOpen);
  };

  const handleSvgClick = () => {
    setShowDropdown(!showDropdown);
  };

  // Auto-open Link Account dialog on landing when no provider is added
  useEffect(() => {
    if (
      !hasAutoOpenedSwitchAccount &&
      !isDemoPath &&
      userData?.isPaymentDone &&
      userData?.added_integrations?.length === 0
    ) {
      setSwitchAccount(true);
      setHasAutoOpenedSwitchAccount(true);
    }
  }, [hasAutoOpenedSwitchAccount, isDemoPath, userData]);

  const getFormattedDate = (date) => {
    const options = { day: '2-digit', month: 'short', year: 'numeric' };
    return date.toLocaleDateString('en-GB', options).replace(',', '');
  };

  const getDateToShow = (entry) => {
    if (entry.C) {
      const yesterday = new Date();
      yesterday.setDate(yesterday.getDate() - 1);
      return getFormattedDate(yesterday);
    } else if (entry.H) {
      const today = new Date();
      return getFormattedDate(today);
    }
    return '';
  };

  const formatInstrumentName = (fullName) => {
    if (!fullName) return '';
    const parts = fullName.split(' ');
    if (parts.length < 2) return fullName;
    const [symbol, monthYear] = parts;
    const year = monthYear.slice(-2);
    const month = monthYear.slice(0, 3);
    return `${symbol}-${month}${year}`;
  };

  const handleDemo = () => {
    if(token){
      navigate('/pricing-plans', { state: { email: userData.email, name : userData.name } });
    }
    else{
      navigate('/signup');
    }
  }

  return (
    <>
      <Card className={`main-card mt-3 ${isDemoPath || userData?.added_integrations?.length === 0 ? 'blur-card' : ''}`}>
        {(isDemoPath || userData?.added_integrations?.length === 0) && (
          <div className="blur-overlay">
            <img
              src={`${process.env.PUBLIC_URL}/images/lock-icon.svg`}
              alt="Lock Icon"
              style={{ height: '20px', width: '16px' }}
              className="lock-icon"
            />
            {isDemoPath && <button className="subscribe-button" onClick={handleDemo}>Subscribe to access</button>}
            {userData?.isPaymentDone && userData?.added_integrations?.length === 0 && (
              <button className="subscribe-button" onClick={handleOpenSwitchAccount}>
                Click to add Provider
              </button>
            )}  
          </div>
        )}
        {/* Card Header */}
        <Card.Header className="pb-0">
          <div className="d-flex justify-content-between mt-1">
            <h2 className="medium-heading mb-0">Watchlist</h2>
            <div>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  onClick={handleSvgClick}
                  style={{ cursor: 'pointer' }}
                  >
                  <path d="M12 13.5C11.7033 13.5 11.4133 13.412 11.1666 13.2472C10.92 13.0824 10.7277 12.8481 10.6142 12.574C10.5006 12.2999 10.4709 11.9983 10.5288 11.7074C10.5867 11.4164 10.7296 11.1491 10.9393 10.9393C11.1491 10.7296 11.4164 10.5867 11.7074 10.5288C11.9983 10.4709 12.2999 10.5006 12.574 10.6142C12.8481 10.7277 13.0824 10.92 13.2472 11.1666C13.412 11.4133 13.5 11.7033 13.5 12C13.5 12.3978 13.342 12.7794 13.0607 13.0607C12.7794 13.342 12.3978 13.5 12 13.5Z" fill="white" />
                  <path d="M18.75 13.5C18.4533 13.5 18.1633 13.412 17.9166 13.2472C17.67 13.0824 17.4777 12.8481 17.3642 12.574C17.2506 12.2999 17.2209 11.9983 17.2788 11.7074C17.3367 11.4164 17.4796 11.1491 17.6893 10.9393C17.8991 10.7296 18.1664 10.5867 18.4574 10.5288C18.7483 10.4709 19.0499 10.5006 19.324 10.6142C19.5981 10.7277 19.8324 10.92 19.9972 11.1666C20.162 11.4133 20.25 11.7033 20.25 12C20.25 12.3978 20.092 12.7794 19.8107 13.0607C19.5294 13.342 19.1478 13.5 18.75 13.5Z" fill="white" />
                  <path d="M5.25 13.5C4.95333 13.5 4.66332 13.412 4.41665 13.2472C4.16997 13.0824 3.97771 12.8481 3.86418 12.574C3.75065 12.2999 3.72094 11.9983 3.77882 11.7074C3.8367 11.4164 3.97956 11.1491 4.18934 10.9393C4.39912 10.7296 4.66639 10.5867 4.95737 10.5288C5.24834 10.4709 5.54994 10.5006 5.82403 10.6142C6.09812 10.7277 6.33238 10.92 6.49721 11.1666C6.66203 11.4133 6.75 11.7033 6.75 12C6.75 12.3978 6.59197 12.7794 6.31066 13.0607C6.02936 13.342 5.64783 13.5 5.25 13.5Z" fill="white" />
                </svg>
              <NavDropdown
                show={showDropdown}
                onToggle={handleToggle}
                title=""
                id="nav-dropdown"
                align="end"
                className="d-inline custom-nav-dropdown"
                style={{ display: showDropdown ? 'block' : 'none' }}
              >
                <NavDropdown.Item className="dropdown-option" onClick={() => removeWidgetFromGrid('watchlist')}>
                  Close Window
                </NavDropdown.Item>
              </NavDropdown>
            </div>
          </div>
          <div className="small-gray small-gary-date">
            {currentDate} | {currentTime}
          </div>
        </Card.Header>

        {/* Card Body */}
        <Card.Body className="pt-0 p-2">
          <div className="table-responsive scrollbar-custom plr-2 w-t-div">
            {/* Table Header (Always Visible) */}
            <Table hover className="watchlist-table">
              <thead>
                <tr>
                  <th className="watchList-head">Name</th>
                  <th className="text-end watchList-head">LTP</th>
                  <th className="text-end watchList-head">Change</th>
                  <th className="text-end watchList-head">Chg%</th>
                </tr>
              </thead>
              {/* Conditional Table Body */}
              <tbody>
                { (watchListLoading || !userData) && !isDemoPath ? (
                  <tr>
                    <td colSpan={4}>
                      <Skeleton
                        count={3}
                        style={{ margin: '4px 2px', borderRadius: '3px' }}
                        baseColor="rgba(137, 136, 137, 0.3)"
                        highlightColor="rgba(176, 176, 176, 0.3)"
                      />
                    </td>
                  </tr>
                  ): isDemoPath || (userData?.added_integrations?.length ?? 0) === 0 ? (
                    <>
                      <tr>
                        <td className="table-text">Corn <br /><span className="small-gray">05 July 2024</span></td>
                        <td className="text-end align-middle">88,650.00</td>
                        <td className="text-success text-end align-middle">32.00</td>
                        <td className="text-success text-end align-middle">0.04</td>
                      </tr>
                      <tr>
                        <td className="table-text">Crude Oil <br /><span className="small-gray">05 Aug 2024</span></td>
                        <td className="text-end align-middle">88,650.00</td>
                        <td className="text-danger text-end align-middle">-25.00</td>
                        <td className="text-danger text-end align-middle">-0.07</td>
                      </tr>
                      <tr className="selected-row">
                        <td className="table-text">Gold <br /><span className="small-gray">05 Aug 2024</span></td>
                        <td className="text-end align-middle">71,470.00</td>
                        <td className="text-success text-end align-middle">26.00</td>
                        <td className="text-success text-end align-middle">0.04</td>
                      </tr>
                      <tr>
                        <td className="table-text">Silver <br /><span className="small-gray">05 July 2024</span></td>
                        <td className="text-end align-middle">88,650.00</td>
                        <td className="text-success text-end align-middle">23.00</td>
                        <td className="text-success text-end align-middle">0.12</td>
                      </tr>
                      <tr>
                        <td className="table-text">Soybeans <br /><span className="small-gray">05 Aug 2024</span></td>
                        <td className="text-end align-middle">88,650.00</td>
                        <td className="text-danger text-end align-middle">-12.00</td>
                        <td className="text-danger text-end align-middle">-3.15</td>
                      </tr>
                    </>
                  ) : watchlistData && watchlistData.length > 0 ? (
                  watchlistData.map((watchList, index) => {
                    const instruments = (watchList.details?.instruments || []).filter(
                      (instrument) => 
                        instrument.fullName && 
                        instrument.fullName.trim() !== '' &&
                        instrument.market_data?.["31"] !== "expired"
                    );
                    return instruments.map((instrument, subIndex) => (
                      <tr key={`${index}-${subIndex}`}>
                        <td className="table-text">
                          {formatInstrumentName(instrument.fullName)} <br />
                          <span className="small-gray">{getDateToShow(instrument)}</span>
                        </td>
                        <td className="text-end align-middle">
                          {!isNaN(Number(instrument?.market_data?.["31"]))
                          ? Number(instrument.market_data["31"]).toFixed(2)
                          : 'N/A'}
                        </td>
                        <td
                          className={`text-end align-middle ${
                            instrument.market_data?.["82"] > 0 ? 'text-success' : 'text-danger'
                          }`}
                        >
                          {!isNaN(Number(instrument?.market_data?.["82"]))
                          ? Number(instrument.market_data["82"]).toFixed(2)
                          : 'N/A'}
                        </td>
                        <td
                          className={`text-end align-middle ${
                            instrument.market_data?.["83"] > 0 ? 'text-success' : 'text-danger'
                          }`}
                        >
                          {!isNaN(Number(instrument?.market_data?.["83"]))
                          ? Number(instrument.market_data["83"]).toFixed(2)
                          : 'N/A'}
                        </td>
                      </tr>
                    ));
                  })
                ) : (
                  <tr>
                    <td colSpan={4} className="text-center mt-3">No Data Available</td>
                  </tr>
                )}
              </tbody>
            </Table>
          </div>
        </Card.Body>
      </Card>
      
      <SwitchAccount open={switchAccount} onClose={handleCloseSwitchAccount}/>
    </>
    
  );
}

export default Watchlist;
